import { elapsedTime, flipClock, theme, css } from 'flipclock';

/**
 * Initialize countdown timers on the page
 * Uses FlipClock's elapsedTime face with FlipClock renderer
 */
export function initializeCountdowns() {
  const countdownElements = document.querySelectorAll('[data-countdown-end]:not([data-countdown-initialized])');

  countdownElements.forEach((element) => {
    // Mark as initialized to prevent duplicate initialization
    element.setAttribute('data-countdown-initialized', 'true');
    
    const endDateString = element.getAttribute('data-countdown-end');
    
    if (!endDateString) {
      console.warn('Countdown element missing data-countdown-end attribute', element);
      return;
    }

    try {
      // Parse the end date
      const endDate = new Date(endDateString);
      
      // Validate the date
      if (isNaN(endDate.getTime())) {
        console.warn('Invalid countdown date:', endDateString);
        return;
      }

      // Apply styling to the container element
      element.style.display = 'flex';
      element.style.justifyContent = 'center';
      element.style.gap = '0.5rem';
      element.style.alignItems = 'center';

      // Create the ElapsedTime face (counts down from now to endDate)
      // For countdown: from = future date (endDate), to = current date (now)
      // This calculates the distance from now until endDate
      // Format: [DD]:[hh]:[mm]:[ss] for Days:Hours:Minutes:Seconds
      const face = elapsedTime({
        from: endDate,
        to: new Date(),
        format: '[DD]:[hh]:[mm]:[ss]',
      });

      // Create the FlipClock instance with all styling via css() options
      const clock = flipClock({
        face: face,
        theme: theme({
          dividers: ':', // Remove dividers since we have labels
          labels: [['D'], ['H'], ['M'], ['S']],
          css: css({
            fontSize: '2rem',
            width: '40px',
            height: '40px',
            borderRadius: '0.5rem',
          })
        }),
        parent: element,
        autoStart: true,
      });

      // Style the FlipClock elements after creation
      const flipClockElement = element.querySelector('.flip-clock');
      if (flipClockElement) {
        flipClockElement.style.justifyContent = 'center';
        flipClockElement.style.fontWeight = '900';
        
        // Style all cards with dark background
        const cards = flipClockElement.querySelectorAll('.flip-clock-card');
        cards.forEach(card => {
          card.style.backgroundColor = '#040203';
          card.style.fontFamily = "'Doto', sans-serif";
          card.style.color = 'white';
        });
        
        // Style labels to be dark colored and positioned below
        const groups = flipClockElement.querySelectorAll('.flip-clock-group');
        groups.forEach(group => {
          const label = group.querySelector('.flip-clock-label');
          if (label) {
            label.style.color = '#040203'; // Dark background color for labels
            label.style.fontWeight = '400';
            label.style.order = '2'; // Put label after the flip cards
            label.style.fontSize = '1rem';
            label.style.paddingTop = '0.5rem';
          }
          
          const items = group.querySelector('.flip-clock-group-items');
          if (items) {
            items.style.order = '1'; // Put flip cards before label
          }

          const dividers = flipClockElement.querySelectorAll('.flip-clock-divider');
          dividers.forEach(divider => {
            divider.style.width = '10px';
            const dividerInner = divider.querySelector('.flip-clock-divider-inner');
            if (dividerInner) {
                dividerInner.style.display = 'none';
            }
          })
          
        });
      }

    } catch (error) {
      console.error('Error initializing countdown:', error, endDateString);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCountdowns);
} else {
  initializeCountdowns();
}
